import { useNavigate } from "react-router-dom";

import styles from "../styles/login.module.scss";

import { useEffect, useState } from "react";
import { Button } from "../shared/components/Button";
import { Input } from "../shared/components/Input";
import { Message } from "../shared/components/Message";

import { Drawer, Loading } from "@components";
import { EnvironmentsAPI } from "../providers/EnvironmentsAPI";
import { OAuthAPI } from "../providers/OAuthAPI";
import { Environment } from "../shared/core/Environment";
import { EnvironmentStorage } from "../shared/tools/EnvironmentStorage";
import { ThemeLoader } from "../shared/tools/ThemeLoader";
import { UserStorage } from "../shared/tools/UserStorage";
import { AccessStorage } from "../storage/AccessStorage";
import { useBroadcastChannel } from "shared/hooks/useBroadcastChannel";
import { AccessManager } from "shared/tools/AccessManager";

export default function Login() {
  const [showPasswordInfo, setShowPasswordInfo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [openLogoutReason, setOpenLogoutReason] = useState(false);
  const [is_session_url, setIsSessionUrl] = useState(true);

  const loginBroadcast = useBroadcastChannel("login");
  const navigation = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("loggedOut")) setOpenLogoutReason(true);
  }, []);

  const logout = () => {
    UserStorage.setAccessToken(null);
    EnvironmentStorage.setEnvironment(null);
    EnvironmentStorage.setConfigurations(null);
    Environment.uninstall();
    localStorage.removeItem("refreshOrdersAuto");
    AccessManager.setPermissions([]);
  };

  const installAccessToken = async (accessToken) => {
    setLoading(true);

    UserStorage.setAccessToken(accessToken);
    UserStorage.setOcdpAccessToken(accessToken);
    AccessStorage.setXUserKey(accessToken);
    AccessStorage.setOlgaXUserKey(accessToken);

    const user = UserStorage.getLoggedUser();
    const availableUnitsResponse = await EnvironmentsAPI.getAvailableUnits(
      user.environment_id
    );
    const firstUnit = availableUnitsResponse.getData([
      { id: user.environment_id, brand: {}, alias: null },
    ])[0];

    EnvironmentStorage.setSelectedEnvironment(firstUnit.id);
    EnvironmentStorage.setEnvironment(firstUnit);


    await ThemeLoader.init();
    if (firstUnit.alias) {
      EnvironmentStorage.setConfigurations(
        await EnvironmentsAPI.getS3Configurations(firstUnit.alias)
      );
    }

    await UserStorage.loadPermissions();

    const extra_menus =
      (await EnvironmentStorage.getEnvironmentExtraMenus()) || {};
    const { cashback, beneficios, avaliacoes } = extra_menus || {};

    const olga_user = UserStorage.getOlgaLoggedUser();
    const envId = olga_user?.environment_id;

    // const olgaActivated = olga_access_token || cashback?.enabled || beneficios?.enabled || avaliacoes?.enabled;

    await Environment.install();
    await Environment.installConfigurations();

    window.dispatchEvent(new CustomEvent("ON_LOGIN", {}));

    loginBroadcast({ message: 'Login realizado as ' + new Date().toString() });

    navigation("/");
    setLoading(false);
  }

  useEffect(() => {
    // Check if query string has access-token and if exists, use it
    const urlParams = new URLSearchParams(window.location.search);
    const access_token = urlParams.get("access_token");
    if (!access_token) {
      setIsSessionUrl(false);
      return;
    }

    logout();

    const handler = async () => {
      const response = await OAuthAPI.refreshToken(access_token);

      if (response.getErrors().length > 0) {
        alert(response.getErrors()[0]);
        return;
      }

      const token = response.getData({ access_token: null })?.access_token;

      await installAccessToken(token);
    }

    handler();

  }, []);

  const onSubmitHandler = async (e) => {
    try {
      e.preventDefault();

      setLoading(true);
      setError(null);

      const response = await OAuthAPI.authenticate(username, password);
      //Validar resposta
      if (response.getCode() === 403) {
        setError(response._errors[0]);
      }

      if (response.getCode(500) != 200) {
        setLoading(false);
        return null;
      }

      const accessToken = response.getData({ access_token: null }).access_token;

      await installAccessToken(accessToken);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  return (
    <div className={styles.loginPage} id="layout">
      <div className={styles.loginContainer}>
        <div className={styles.logo}>
          <img src="/logo-olga.png" alt="Logo Olga" />
        </div>
        {is_session_url && (
          <Loading fullScreen />
        )}
        <form onSubmit={onSubmitHandler}>
          <Input
            design="olga"
            name="username"
            floatLabel="Nome de usuário"
            className="mb-20"
            onChange={(e) => setUsername(e.target.value)}
            disabled={loading}
          />
          <Input
            design="olga"
            name="password"
            type="password"
            floatLabel="Senha"
            className="mb-20"
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
          />

          {error && (
            <div className="mb-20">
              <Message text={error} />
            </div>
          )}

          <Button
            type="submit"
            design="primary-olga"
            className="w-100"
            loading={loading}
            disabled={loading}
          >
            Entrar
          </Button>

          <div className="d-flex flex-column align-center">
            <Button
              design="underline"
              className="mt-20 mb-20"
              onClick={() => setShowPasswordInfo(true)}
            >
              Esqueceu sua senha?
            </Button>

            {showPasswordInfo && (
              <Message text="Entre em contato com seu superior para recuperar sua senha" />
            )}
          </div>
        </form>

        <Drawer
          visible={openLogoutReason}
          onClose={() => {
            setOpenLogoutReason(false);
            localStorage.clear("loggedOut");
          }}
          direction="top-alert"
          showCloseButton={false}
        >
          <p className={styles.logoutReason}>
            Você foi desconectado devido a uma alteração realizada em seu
            usuário.
          </p>
        </Drawer>
      </div>
    </div>
  );
}
